import * as actionTypes from './actionType';

const axiosPayLoad = {
  isUserDefaultSet: true,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.IS_SER_DEFAULT_MSG_SET:
      return {
        ...state,
        isUserDefaultSet: action.isUserDefaultSet,
      };
    default:
      return state;
  }
};

export default reducer;
